import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import {useNavigate} from "react-router-dom"
function Login() {
  const navigate = useNavigate()
  // Yup Validation Schema
  const validationSchema = Yup.object({
    mobile: Yup.string()
      .matches(/^[6-9]\d{9}$/, "Please enter a valid 10-digit mobile number")
      .required("Mobile number is required"),
  });

  // Formik Hook
  const formik = useFormik({
    initialValues: {
      mobile: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("OTP Sent to:", values.mobile);
      navigate("/otp-verification")
    },
  });

  return (
    <div className="scr on" id="s-login" style={{background:"white"}}>
      <div className="lg-top">
        <div className="lg-logo">
          <img src="/brandLogo.png" style={{height:"100px", width:"100px", borderRadius:"50%"}}/>
        </div>
        <div
          className="playfair"
          style={{ fontSize: "1.8rem", color: "#fff", fontWeight: 800 }}
        >
          Bahurani Kitchen
        </div>
        <div
          style={{
            color: "rgba(255,255,255,0.72)",
            fontSize: "0.85rem",
            marginTop: 3,
            // letterSpacing: '0.5px',
            fontFamily:"monospace"
          }}
        >
          Authentic Flavors, Delivered with Love
        </div>
      </div>

      <div className="lg-card" >
        <h2 className="au">Welcome Back!</h2>
        <div className="sub au2" style={{ marginBottom: '20px' }}>
          Login to access your personalized menu
        </div>
        
        <form onSubmit={formik.handleSubmit}>
          <div style={{ marginBottom: 16 }} className="au3">
            <div className="lbl" style={{ fontWeight: '600' }}>Mobile Number</div>
            <div className={`ph-row ${formik.touched.mobile && formik.errors.mobile ? 'error-border' : ''}`}>
              <div className="ph-pre">🇮🇳 +91</div>
              <input
                name="mobile"
                type="tel"
                placeholder="Enter 10 digit number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.mobile}
                style={{ outline: 'none' }}
              />
            </div>
            {/* Error Message */}
            {formik.touched.mobile && formik.errors.mobile ? (
              <div style={{ color: '#d32f2f', fontSize: '0.75rem', marginTop: '5px', marginLeft: '5px' }}>
                {formik.errors.mobile}
              </div>
            ) : null}
          </div>

          <button 
            type="submit" 
            className="btn btn-or btn-full au4" 
            style={{ cursor: 'pointer' }}
          >
            Request Secure OTP 
          </button>
        </form>

        <div className="dvd">or continue with</div>
        
        <div className="soc-row">
          <button className="soc-btn" type="button">
            <svg width={16} height={16} viewBox="0 0 24 24" style={{ marginRight: '8px' }}>
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            Google
          </button>
          <button className="soc-btn" type="button">👤 Guest Mode</button>
        </div>

        <div className="terms">
          By continuing, you acknowledge that you have read and agree to our 
          <span style={{ color: '#E65100', cursor: 'pointer' }}> <b>Terms</b></span> and 
          <span style={{ color: '#E65100', cursor: 'pointer' }}> <b>Privacy Policy</b></span>.
        </div>
      </div>
    </div>
  );
}

export default Login;